import HomeArea from "./HomeArea";
import FeatureArea from "./FeatureArea/FeatureArea";
import TutorialArea from "./TutorialArea/TutorialArea";
import WhiteListArea from "./WhiteListArea";
import "../../css/home-light.css";

export default function Main() {
  return (
    <>
      {/* pl-home scopes the homepage's light multi-colour theme
          (css/home-light.css) so the account, invoice and legal pages keep the
          plain white background they already had. */}
      <main className="overflow-hidden pl-home">
        {/* <|-- home area --> */}
        <HomeArea />

        {/* <!-- feature area --> */}
        <FeatureArea />

        {/* <!-- tutorial area --> */}
        

        {/* <!-- whitelist area --> */}
        
      </main>
    </>
  );
}
